export default "/images/88721c15f8a21a7110ffca4ed8dad6f4.avif";